<template>

  <div>

    <button
      @click.once="handler(action)"
      class="nectar-button cursor-pointer text-left break-words"
      :style="buttonStyle"
      :class="buttonClass"
      :disabled="isDisabled"
    >
      <i v-if="showIcon" class="fa fa-briefcase" style="color: rgb(255, 255, 255);"></i>
      <span v-html="buttonText" :class="textClass" :style="textStyle"></span>
    </button>

    <slot></slot>

  </div>

</template>

<script>

import { mapActions } from 'vuex'

import VaIcon from '@/components/VaIcon.vue';

export default {

  name: 'VaAnswerButton',

  components: {
    VaIcon
  },

  props: {
          answer : { type: Object,  required: true },
          action : { type: Object,  required: true },
            text : { type: String,  default: '' },

    btnClassBase : { type: String,  default: 'cursor-pointer' },
        btnClass : { type: String,  default: '' },

    btnStyleBase : { type: String,  default: '' },
        btnStyle : { type: String,  default: '' },

       textClass : { type: String,  default: '' },
       textStyle : { type: String,  default: '' },

        showIcon : { type: Boolean, default: false },
        isDisabled : { type: Boolean, default: false }

  },

  computed: {

    buttonClass () {
      return [this.btnClassBase, this.btnClass].join(" ");
    },

    buttonStyle () {
      return [this.btnStyleBase, this.btnStyle].join(" ");
    },

    buttonText () {
      return this.text || this.answer.text || '';
    }

  },

  methods: {

    handler (action) {
      this.$emit('applyAction', action || this.action || {});
    }
  }

};
</script>
